import { render } from "./ModalPasteSakuhin.vue?vue&type=template&id=23617c8f&scoped=true"
import script from "./ModalPasteSakuhin.vue?vue&type=script&lang=js"
export * from "./ModalPasteSakuhin.vue?vue&type=script&lang=js"

import "./ModalPasteSakuhin.vue?vue&type=style&index=0&id=23617c8f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23617c8f"]])

export default __exports__